import ExcelJS from "exceljs";
import { saveAs } from 'file-saver';
import DrawExcel from "@/commonFuncion/DrawExcel";

export async function exportExcelSepay(exportToExcelData,  listDataExportExcel, typeApp) {

    const fileName = exportToExcelData.nameFile;
    const workbook = new ExcelJS.Workbook();

    const sheetName = "ONEKIDS"

    await addDataList(workbook, sheetName,listDataExportExcel,typeApp);
    // Dữ liệu truyền vào từ component
    async function addDataList(workbook, sheetName) {
        const titleFile = exportToExcelData.titleFile;
        let columnHeaders = []
        if (typeApp === 'plus'){
            columnHeaders = [
                'STT', 'ID giao dịch', 'Họ tên', 'Mã học sinh', 'Lớp', 'Số tài khoản ngân hàng', 'Tên tài khoản',
                'Thời gian nhận giao dịch', 'Tên ngân hàng','ID VA', 'Số VA', 'Mã tham chiếu', 'Nội dung giao dịch',
                'Mã thanh toán', 'Loại giao dịch', 'Số tiền giao dịch', 'Trạng thái gửi webhook'
            ]
        }else {
            columnHeaders = [
                'STT','Đại lý', "Tên trường", 'ID giao dịch',  'Họ tên', 'Mã học sinh', 'Lớp',  'Thời gian nhận giao dịch', 'Số tài khoản ngân hàng', 'Tên tài khoản',
               'Tên ngân hàng','ID VA', 'Số VA', 'Mã tham chiếu', 'Nội dung giao dịch',
                'Mã thanh toán', 'Loại giao dịch', 'Số tiền giao dịch', 'Trạng thái gửi webhook'
            ]
        }

        const companyInfo = exportToExcelData.companyInfo;
        const columnWidths = exportToExcelData.columnWidths;
        let dataList = []
        dataList = await  getDataTable(sheetName,listDataExportExcel,typeApp)

        const worksheet = workbook.addWorksheet(sheetName);

        await DrawExcel.drawColumnWidths(columnWidths, worksheet);

        await DrawExcel.drawCompanyInfo(companyInfo, worksheet);
        await DrawExcel.drawTitleRowNew(titleFile, worksheet);
        worksheet.addRow([]);
        await DrawExcel.drawTableHeadersStatistics(columnHeaders, worksheet);
        await DrawExcel.drawTableStatistics(dataList, worksheet);

    }
    async function getDataTable(sheetName,listDataExportExcel,typeSheet){
        let dataList = []
        if (typeSheet === 'plus'){
            for (let i = 0; i < listDataExportExcel.length; i++) {
                    dataList.push(listDataExportExcel[i])
            }
            return dataList.map((x, index) => [
                index + 1,
                x.transactionId,
                x.fullName,
                x.kidCode,
                x.className,
                x.accountNumber,
                x.nameAccount,
                x.transactionDate,
                x.nameBank,
                x.idVa,
                x.va,
                x.referenceNumber,
                x.contentOGV,
                x.paymentCode,
                x.transferType,
                x.amount,
                x.receiveWebhook === true ? "Thành công" : x.receiveWebhook === false ? "Thất bại" : ""
            ]);
        }else {
            for (let i = 0; i < listDataExportExcel.length; i++) {
                    dataList.push(listDataExportExcel[i])
            }
            return dataList.map((x, index) => [
                index + 1,
                x.nameCompany,
                x.nameSchool,
                x.transactionId,
                x.fullName,
                x.kidCode,
                x.className,
                x.transactionDate,
                x.accountNumber,
                x.nameAccount,
                x.nameBank,
                x.idVa,
                x.va,
                x.referenceNumber,
                x.contentOGV,
                x.paymentCode,
                x.transferType,
                x.amount,
                x.receiveWebhook === true ? "Thành công" : x.receiveWebhook === false ? "Thất bại" : ""
            ]);
        }


    }
    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), fileName + '.xlsx');

}

